var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.547,
    height: 21.548
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 470",
    d: "M13.684 20.712a5.3 5.3 0 006.6-.717l.742-.74a1.767 1.767 0 000-2.5l-3.123-3.123a1.764 1.764 0 00-2.5 0 1.767 1.767 0 01-2.5 0l-5-5a1.767 1.767 0 010-2.5 1.764 1.764 0 000-2.5L4.793.518a1.768 1.768 0 00-2.5 0l-.74.742a5.3 5.3 0 00-.717 6.6 47.845 47.845 0 0012.848 12.852z",
    fill: "#690"
  })));
}

export default __webpack_public_path__ + "be60825d99c59622f43403cc0c7beb29.svg";
export { SvgPhone as ReactComponent };